import Footer from "../../components/Footer/Footer";
import NavBar from "../../components/Navigation/NavBar";

export default function PrivacyPage() {
  return (
    <>
      <NavBar />
      <main className="max-w-4xl mx-auto px-4 py-8 text-gray-800">
        <h1 className="text-3xl font-bold text-center mb-4">Privacy Policy</h1>
        <p className="text-center text-sm text-gray-500 mb-10">Last Updated: 09th July 2023</p>

        <Section title="1. Introduction">
          <p>
            This Privacy Policy complements our Terms of Service and outlines how NextLoop Pte Ltd (“NextLoop”), along with its affiliated companies and subsidiaries that link to this Privacy Policy, handle the collection and usage of information during your utilization of our websites, mobile applications, and services (referred to as the "Services"). It also governs the disclosure, use, and collection of your information.
          </p>
        </Section>

        <Section title="2. Information collection and reception">
          <p>We may collect and receive information from you in the following circumstances:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>When you register an account with us ("Account").</li>
            <li>When you choose to link your Account with third-party services like Facebook or Google.</li>
            <li>When you create listings, chat, or transact with other users.</li>
            <li>When you contact us with inquiries or issues.</li>
            <li>When you join surveys, campaigns, contests, or lucky draws.</li>
            <li>When you interact with us offline or through external parties.</li>
            <li>By providing third-party info (e.g. spouse, employee), you confirm their consent.</li>
          </ul>
          <p className="mt-4">Information we may collect includes:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Account credentials (e.g. username).</li>
            <li>Profile info (name, gender, email, photo, phone, birthdate).</li>
            <li>Payment details and address/location info.</li>
            <li>Aggregate usage data and user communications.</li>
          </ul>
        </Section>

        <Section title="3. Interactions with others">
          <p>
            Our Services allow you to connect and communicate with others. Be mindful when sharing info in public/semi-public groups. Such content may persist even after account deletion. You are solely responsible for what you choose to share.
          </p>
        </Section>

        <Section title="4. Purpose of information collection and use">
          <p>We use your information to:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Update you on listings and features via email/push notifications.</li>
            <li>Send marketing communications (with opt-out options).</li>
            <li>Verify identity and manage your account.</li>
            <li>Customize and improve services.</li>
            <li>Process payments and handle disputes.</li>
            <li>Detect fraud and ensure safety.</li>
            <li>Respond to inquiries and complaints.</li>
            <li>Send service-related messages (non-promotional).</li>
            <li>Provide personalized advertising.</li>
            <li>Conduct research and surveys.</li>
          </ul>
        </Section>

        <Section title="5. Disclosure of Your Information">
          <ul className="list-disc pl-6 space-y-1">
            <li>Shared with users on your profile or via content you post.</li>
            <li>Shared with service providers for tasks like payments or support.</li>
            <li>Shared with affiliates, partners, and analytics/marketing platforms.</li>
            <li>Shared with authorities or financial institutions when required.</li>
            <li>Shared in aggregated form with third parties for lawful purposes.</li>
          </ul>
        </Section>

        <Section title="6. Transfer of Information">
          <p>
            By using our Services, you authorize data transfer to Singapore and other regions where we operate. We comply with laws such as the Personal Data Protection Act 2012 of Singapore.
          </p>
        </Section>

        <Section title="7. Protection of Your Information">
          <p>
            We implement security measures (e.g., SSL) to protect your data, but no method is 100% secure. Keep your password confidential and log out after use.
          </p>
        </Section>

        <Section title="8. Accessing and Updating Your Information">
          <p>
            You can update your personal info via your Account. Ensure your details are accurate and up to date. When providing third-party data, ensure they’re informed and have consented.
          </p>
        </Section>
      </main>
      <Footer />
    </>
  );
}

function Section({ title, children }) {
  return (
    <section className="mb-10">
      <h2 className="text-l font-semibold text-gray-800 mb-2">{title}</h2>
      <div className="space-y-4 text-sm leading-relaxed text-gray-700">{children}</div>
    </section>
  );
}
